import { createIdentifier } from '@wix/thunderbolt-ioc'
import { CssFeature } from '../types'

export const CssFeatureSymbol = createIdentifier<CssFeature<any>>(Symbol('CssFeatureSymbol'))
